<template>
  <div>
    <v-chart :option="options" :init-options="{renderer: 'svg'}" autoresize :style="`height: ${height}px; width: 100%;`"/>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import { graphic } from 'echarts/core'
import 'zrender/lib/svg/svg'
import numbro from 'numbro'

export default {
  data () {
    return {}
  },
  computed: {
    height: function () {
      return Object.keys(this.data).length * 25 + 8
    },
    options () {
      return {
        textStyle: {
          fontFamily: '"Roboto","Helvetica",sans-serif',
          lineHeight: 1.2381,
          fontWeight: 400
        },
        grid: {
          top: 5,
          left: 240,
          right: 30,
          bottom: 3,
          containLabel: false
        },
        xAxis: {
          type: 'value',
          show: false,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: this.sortedData.map(item => {
            return item[0]
          })
        },
        series: this.series
      }
    },
    sortedData: function () {
      // Sort desc by value
      return Object.entries(this.data).sort((a, b) => a[1] - b[1])
    },
    series: function () {
      var series = []
      this.sortedData.forEach((element, index) => {
        var dataArray = this.sortedData.map((el, elIndex) => index === elIndex ? el[1] : null)
        series.push({
          name: element[0],
          type: 'bar',
          stack: 'stack',
          barWidth: 15,
          label: {
            show: true,
            position: 'right',
            formatter: this.formatEchartsValue
          },
          itemStyle: {
            color: new graphic.LinearGradient(2, 0, 0, 0, [
              { offset: 0, color: 'white' },
              { offset: 1, color: this.colors ? this.colors[index] : 'blue' }
            ]),
            borderRadius: [0, 2, 2, 0]
          },
          data: dataArray
        })
      })
      return series
    }
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    formatEchartsValue: function (obj) {
      return this.formatValue(obj.value)
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: Array,
      required: false
    }
  },
  components: {
    'v-chart': ECharts
  }
}
</script>
